// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"353":"a3958aba","467":"94672c6f","819":"7bea0f15"}[chunkId] + ".css";
};